import { useContext, useEffect, useState } from "react";

// style
import Style from "./ModalApplicationSubmitted.module.css";

// context
import { FirstInputFormDataContext } from "../../../context/FirstInputFormDataContext";

const ModalApplicationSubmitted = (height, width, modalMessage) => {
  const [heightPercentage, setHeightPercentage] = useState("25%");
  const [widthPercentage, setWidthPercentage] = useState("30%");
  const [message, setMessage] = useState("Prijava uspješno poslana!");

  const { setModalApplicationSubmittedIsOpen } = useContext(
    FirstInputFormDataContext
  );

  useEffect(() => {
    if (height) {
      setHeightPercentage(height);
    }

    if (width) {
      setWidthPercentage(width);
    }

    if (modalMessage) {
      setMessage(modalMessage);
    }
  }, [height, width, modalMessage]);

  const handleYesButton = () => {
    setModalApplicationSubmittedIsOpen(false);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  return (
    <div className={Style.ModalContainerOverlay}>
      <div
        className={Style.Modal}
        style={{ height: heightPercentage, width: widthPercentage }}
      >
        <h3 className={Style.ModalQuestion}>{message}</h3>

        <div className={Style.ModalButtonsContainer}>
          <button
            onClick={() => handleYesButton()}
            className={Style.ModalYesButton}
          >
            U REDU
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalApplicationSubmitted;
